import OnlineFormTransmitReport from './OnlineFormTransmitReport';

export default OnlineFormTransmitReport;
